import legoDateTimePicker from './legoDateTimePicker.vue';
export default {
  install(Vue) {
    Vue.component(legoDateTimePicker.name, legoDateTimePicker);
  },
};
